import { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { stylesGeneralComponents } from "../../../../StylesMuiGeneralComponents";
import { LoadingButton } from "@mui/lab";
import { StoragesValuesView } from "../../../../../redux/slices/grainTracker/grainTrackerTypes";
import { FetchingSharingStatusData } from "../../../../../redux/slices/shareSite/shareSiteTypes";

type ShareSiteUnselectAllParams = {
  setSelectedStoragesIds: (values: string[]) => void;
  storagesLoading: boolean;
  storageSharingLoading: boolean;
  storageSharedDeleteLoading: boolean;
  setToDelete: (values: string[]) => void;
  storages: StoragesValuesView[];
  selectedStoragesIds: string[];
  sharingStatus: FetchingSharingStatusData;
};

const ShareSiteButtonUnselectAll: FC<ShareSiteUnselectAllParams> = ({
  setSelectedStoragesIds,
  storagesLoading,
  storageSharedDeleteLoading,
  storageSharingLoading,
  setToDelete,
  storages,
  selectedStoragesIds,
  sharingStatus,
}) => {
  const [t] = useTranslation("global");

  const sharingStatusObject = sharingStatus.data.map((val) => ({
    id: val.id,
    storageInstanceId: val.storageInstanceId,
    sharingIsForced: val.sharingIsForced,
  }));

  const storagesWithStatusInformation = storages.reduce((arr: any, e: any) => {
    arr.push(
      Object.assign({}, e, {
        sharingStatus: sharingStatusObject.find(
          (a) => a.storageInstanceId === e.id,
        ),
      }),
    );
    return arr;
  }, []) as StoragesValuesView[];

  const passToDelete = storagesWithStatusInformation
    .filter((c) =>
      selectedStoragesIds.find((v) => c.sharingStatus?.storageInstanceId === v),
    )
    .filter((x) => x.sharingStatus?.sharingIsForced !== true)
    .map((x) => x.id);

  const passToSelectForced = storagesWithStatusInformation
    .filter((card) => card.sharingStatus?.sharingIsForced === true)
    .map((val) => val.id);

  const unselectAll = () => {
    setSelectedStoragesIds(passToSelectForced);
    setToDelete(passToDelete);
  };

  return (
    <Box sx={stylesGeneralComponents.boxButtonFiltersShareSite}>
      <LoadingButton
        sx={stylesGeneralComponents.buttonStyles}
        loading={
          storagesLoading || storageSharedDeleteLoading || storageSharingLoading
        }
        loadingPosition="end"
        variant="text"
        onClick={() => unselectAll()}
      >
        {t("Share_site.deselect-all")}
      </LoadingButton>
    </Box>
  );
};

export default ShareSiteButtonUnselectAll;
